export default "__VITE_ASSET__gq9XG55F__"